import { useCallback, useEffect, useState } from 'react'
import { Avatar, Button, Col, Input, message, Row } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { SActionBtn, SFuncModal } from 'shj-components'
import classNames from 'classnames'
import useGlobalStore from '@/store'

import ImageUpload from '@/components/Upload/ImageUpload.tsx'
import EditPasswordForm from './addOrEdit/password.tsx'
import styles from './index.module.less'
import EditPhoneForm from '@/pages/homePage/personalCenter/addOrEdit/phone.tsx'
import EditEmailForm from '@/pages/homePage/personalCenter/addOrEdit/email.tsx'
import CheckIDForm from '@/pages/homePage/personalCenter/addOrEdit/idCheck.tsx'
import { getUCenterInfo, uCenterUpdateAvatar, uCenterUpdateName } from '@/services'
import { getLocalCheckInfo } from '@/common/utils.ts'
import TextBtn from '@/pages/homePage/personalCenter/TextBtn.tsx'

const PersonalCenter = () => {
  const globalUser = useGlobalStore((state: any) => state.user)
  const setUser = useGlobalStore((state: any) => state.setUser)
  const checkInfo = JSON.parse(getLocalCheckInfo() || null) || {}

  const [userInfo, setUserInfo] = useState<Record<string, any>>({})
  const [userName, setUserName] = useState<string>('')
  const [isEditName, setIsEditName] = useState(false)
  const [isCheckOk, setIsCheckOk] = useState(false)

  useEffect(() => {
    getUserInfo()
  }, [])

  const getUserInfo = () => {
    getUCenterInfo(globalUser?.id).then(res => {
      setUserInfo(res || {})
      setUserName(res?.tenantUserName || '')
    })
  }

  const onChangeUserName = (value: string) => {
    const tenantUserName = value.trim()
    setUserName(tenantUserName)
  }

  const onSaveName = () => {
    if (!userName) return message.info('名称不能为空')
    uCenterUpdateName({ name: userName }).then(() => {
      message.success('修改成功')
      setUserInfo({ ...userInfo, name: userName })
      setUser({ ...globalUser, name: userName })
      setIsEditName(false)
    })
  }

  const onChangeImg = file => {
    const fileObj = file[0]
    if (fileObj) {
      const url = fileObj.response.data.fileUrl
      uCenterUpdateAvatar({ avatar: url }).then(() => {
        setUserInfo({ ...userInfo, tenantAvatar: url })
        setUser({ ...globalUser, photo: url })
        localStorage.setItem('user', JSON.stringify({ ...globalUser, photo: url }))
      })
    }
  }

  const onEditForm = useCallback(
    (editForm: () => void) => {
      const startTime = checkInfo?.[userInfo.userId]
      const time = startTime ? +new Date() - startTime : 60 * 60 * 10000
      if (time > 60 * 60 * 1000 || !startTime) return onCheckId(editForm)
      editForm()
    },
    [isCheckOk, userInfo]
  )

  const onChangePassword = () => {
    const destroy = () => {
      dialog.destroy()
    }
    const dialog: any = SFuncModal({
      title: '修改密码',
      vanish: true,
      content: <EditPasswordForm data={userInfo} onClose={destroy} />,
    })
  }

  const onChangePhone = () => {
    const destroy = (phone?) => {
      phone && setUserInfo({ ...userInfo, phone })
      dialog.destroy()
    }
    const dialog: any = SFuncModal({
      title: '修改手机号',
      vanish: true,
      content: <EditPhoneForm onClose={destroy} />,
    })
  }

  const onChangeEmail = () => {
    const destroy = (email?) => {
      email && setUserInfo({ ...userInfo, email })
      dialog.destroy()
    }
    const dialog: any = SFuncModal({
      title: '绑定邮箱',
      vanish: true,
      content: <EditEmailForm data={{}} onClose={destroy} />,
    })
  }

  const onCheckId = (onOpenForm: () => void) => {
    const destroy = () => {
      dialog.destroy()
    }
    const dialog: any = SFuncModal({
      title: '身份验证',
      vanish: true,
      content: (
        <CheckIDForm
          onChangeCheckState={state => setIsCheckOk(state)}
          data={userInfo}
          checkInfo={checkInfo}
          onOpenForm={onOpenForm}
          onClose={destroy}
        />
      ),
    })
  }

  return (
    <div className={styles.info_box}>
      <h3 className={styles.ml_16}>基本信息</h3>
      <div className={styles.item}>
        <p className={styles.label}>用户头像</p>
        <div className={styles.item_right}>
          {userInfo.tenantAvatar ? (
            <Avatar
              className={classNames([styles.mr_20, styles.ml_8])}
              size={52}
              icon={<UserOutlined />}
              src={userInfo.tenantAvatar}
            />
          ) : (
            <div className={styles.avatar_box}>{userInfo.name?.slice(-2)}</div>
          )}
          <ImageUpload
            listType={'text'}
            onChange={onChangeImg}
            showUploadList={false}
            accept={'.png,.jpg,.jpeg,.webp'}
            maxCount={1}
          >
            <TextBtn>修改</TextBtn>
          </ImageUpload>
        </div>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>用户名称</p>
        <div className={styles.item_right}>
          <Input
            className={styles.input}
            value={userName}
            maxLength={20}
            onChange={e => onChangeUserName(e.target.value)}
            allowClear={isEditName}
            style={{ marginLeft: -3, borderColor: isEditName ? '' : 'transparent' }}
            readOnly={!isEditName}
          />
          <Row wrap={false} style={{ marginLeft: 6, flexShrink: 0, minWidth: 120 }} justify="end">
            <Col>{isEditName ? <TextBtn onClick={() => onSaveName()}>保存</TextBtn> : null}</Col>
            <Col>
              {isEditName ? (
                <TextBtn onClick={() => setIsEditName(false)}>取消</TextBtn>
              ) : (
                <TextBtn onClick={() => setIsEditName(!isEditName)}>修改</TextBtn>
              )}
            </Col>
          </Row>

          {/*{isEditName ? (*/}
          {/*  <>*/}
          {/*    */}
          {/*  </>*/}
          {/*) : (*/}
          {/*  <>*/}
          {/*    <span className={classNames([styles.mr_20, styles.ml_8])}>{userInfo.name}</span>*/}
          {/*    <TextBtn onClick={() => setIsEditName(!isEditName)}>修改</TextBtn>*/}
          {/*  </>*/}
          {/*)}*/}
        </div>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>登录账号</p>
        <p className={styles.ml_8}>{userInfo.loginAccount}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>语言</p>
        <p className={styles.ml_8}>简体中文</p>
      </div>
      <h3 className={styles.ml_16}>账号安全</h3>
      <div className={styles.item}>
        <p className={styles.label}>密码</p>
        <div className={styles.item_right}>
          <span></span>
          <TextBtn
            // onClick={() => onEditForm(onChangePassword)}
            onClick={onChangePassword}
          >
            {!userInfo.requireChangePassword ? '修改' : '绑定'}
          </TextBtn>
        </div>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>手机</p>
        <div className={styles.item_right}>
          <span className={classNames([styles.mr_20, styles.ml_8])}>+86-{userInfo.phone}</span>
          <TextBtn onClick={() => onEditForm(onChangePhone)}>
            {userInfo.phone ? '修改' : '绑定'}
          </TextBtn>
        </div>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>邮箱</p>
        <div className={styles.item_right}>
          <span className={classNames([styles.mr_20, styles.ml_8])}>{userInfo.email}</span>
          <TextBtn onClick={() => onEditForm(onChangeEmail)}>
            {userInfo.email ? '修改' : '绑定'}
          </TextBtn>
        </div>
      </div>
    </div>
  )
}

export default PersonalCenter
